module.exports = __webpack_public_path__ + "static/media/Visa_Electron.d6c3df9b.svg";